// Generated from SVG to Code Figma Plugin
'use client';
import React from 'react';
import { chakra } from '@chakra-ui/react';
import { useColorMode } from '@/components/ui/color-mode';
type Props = {
  width?: number;
  fill?: string;
};
export const X = ({ fill = 'none', width = 14 }: Props) => {
  const { colorMode } = useColorMode();
  const fillColor = colorMode === 'light' ? 'black' : 'white';
  return (
    <chakra.svg
      height={`${width}px`}
      width={`${width}px`}
      fill={fill}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.96984 2.33301H11.5532L8.09408 6.28651L12.1634 11.6663H8.97715L6.48156 8.4035L3.62606 11.6663H2.04179L5.74162 7.43762L1.83789 2.33301H5.10504L7.36081 5.31537L9.96984 2.33301ZM9.41414 10.7186H10.2915L4.62832 3.23092H3.68685L9.41414 10.7186Z"
        fill={fillColor}
        fillOpacity="0.4"
      />
    </chakra.svg>
  );
};
